export default "/welcome/logo.svg"